import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

// Pages
import HomePage from "./pages/HomePage";
import KoeletransportPage from "./pages/KoeletransportPage";
import MedicinaltransportPage from "./pages/MedicinaltransportPage";
import FoedevaretransportPage from "./pages/FoedevaretransportPage";
import TransportpartnerPage from "./pages/TransportpartnerPage";
import OmOsPage from "./pages/OmOsPage";
import KoeretoejerPage from "./pages/KoeretoejerPage";
import KontaktPage from "./pages/KontaktPage";
import PrivatlivspolitikPage from "./pages/PrivatlivspolitikPage";
import NotFoundPage from "./pages/NotFoundPage";
import ForbiddenPage from "./pages/ForbiddenPage";

export default function App() {
  return (
    <div className="flex flex-col min-h-screen bg-[#070d18] text-slate-100 selection:bg-[#0F766E] selection:text-white">
      <ScrollToTop />
      <Header />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/ydelser/koeletransport" element={<KoeletransportPage />} />
          <Route path="/ydelser/medicinaltransport" element={<MedicinaltransportPage />} />
          <Route path="/ydelser/foedevaretransport" element={<FoedevaretransportPage />} />
          <Route path="/ydelser/transportpartner" element={<TransportpartnerPage />} />
          <Route path="/om-kvc-express" element={<OmOsPage />} />
          <Route path="/vores-koeretoejer" element={<KoeretoejerPage />} />
          <Route path="/kontakt" element={<KontaktPage />} />
          <Route path="/privatlivspolitik" element={<PrivatlivspolitikPage />} />
          <Route path="/403" element={<ForbiddenPage />} />
          <Route path="/404" element={<NotFoundPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
